import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function SidebarFilterCareer({ filters, onFilterChange }) {
    const [categories, setCategories] = useState([]);
    const [countries, setCountries] = useState([]);

    // ব্যাকএন্ড থেকে ডাইনামিক ক্যাটাগরি এবং কান্ট্রি লিস্ট নিয়ে আসা
    const API_URL = process.env.REACT_APP_API_BASE_URL;
    const CATEGORIES_ENDPOINT = process.env.REACT_APP_API_CATEGORIES;
    const COUNTRIES_ENDPOINT = process.env.REACT_APP_API_COUNTRIES;

    useEffect(() => {
        axios.get(`${API_URL}${CATEGORIES_ENDPOINT}`)
            .then(res => setCategories(res.data.data || res.data))
            .catch(err => console.error("Error fetching categories", err));

        axios.get(`${API_URL}${COUNTRIES_ENDPOINT}`)
            .then(res => setCountries(res.data.data || res.data))
            .catch(err => console.error("Error fetching countries", err));
    }, []);

    const handleChange = (type, value) => {
        if (type === 'category') {
            const updatedCategories = filters.categories.includes(value)
                ? filters.categories.filter(item => item !== value)
                : [...filters.categories, value];
            onFilterChange({ ...filters, categories: updatedCategories });
        } else if (type === 'country') {
            const updatedCountries = filters.countries.includes(value)
                ? filters.countries.filter(item => item !== value)
                : [...filters.countries, value];
            onFilterChange({ ...filters, countries: updatedCountries });
        }
    };

    return (
        <div className="card shadow-sm border-0 p-3 bg-white text-dark" style={{ fontSize: '13px' }}>
            {/* Categories Filter (Dynamic from DB) */}
            <div className="mb-4">
                <h6 className="fw-bold text-uppercase text-secondary mb-3" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Categories</h6>
                <div className="d-flex flex-column gap-2" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                    {categories.map((cat) => (
                        <div className="form-check" key={cat.id}>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id={`cat-${cat.id}`}
                                checked={filters.categories.includes(cat.name)}
                                onChange={() => handleChange('category', cat.name)}
                            />
                            <label className="form-check-label text-muted text-truncate" htmlFor={`cat-${cat.id}`}>{cat.name}</label>
                        </div>
                    ))}
                </div>
            </div>

            <hr className="text-muted opacity-25" />

            {/* Country Filter (Dynamic from DB) */}
            <div>
                <h6 className="fw-bold text-uppercase text-secondary mb-3" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Countries</h6>
                <div className="d-flex flex-column gap-2" style={{ maxHeight: '220px', overflowY: 'auto' }}>
                    {countries.map((country) => (
                        <div className="form-check" key={country.id}>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id={`country-${country.id}`}
                                checked={filters.countries.includes(country.name)}
                                onChange={() => handleChange('country', country.name)}
                            />
                            <label className="form-check-label text-muted" htmlFor={`country-${country.id}`}>{country.name}</label>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}